import { getAuthUserUrl, getMeUrl, getClient } from '@/stores/auth';
import { useInstanceStore } from '@/stores/instance';

/** Figure out the appropriate instance to fetch depending on the state */
const getHost = () => {
  const accountUrl = getMeUrl() ?? (getAuthUserUrl() as string);

  try {
    return new URL(accountUrl).host;
  } catch {
    return null;
  }
};

const fetchInstance = async () => {
  try {
    const client = getClient();
    const instance = await client.instance.getInstance();

    useInstanceStore.getState().actions.loadInstance(instance);
    useInstanceStore.getState().actions.setInstanceFetchFailed(false);
  } catch (error) {
    useInstanceStore.getState().actions.instanceFetchFailed(error);
    useInstanceStore.getState().actions.setInstanceFetchFailed(true);
  }
};

export { getHost, fetchInstance };
